/* eslint-disable import/no-anonymous-default-export */
import Head from "next/head";
import SEO from "@/components/seo/seo-metadata";
import { getData } from "../utils/academy-stack";
import sanitize from "sanitize-html";

export default function NotFound({ pageData }) {
  pageData.url = "/404";

  return (
    <>
      <SEO pageData={pageData} canonical={false}/>
      <Head>
        <meta name="robots" content="noindex" />
      </Head>
      <div className="container filenotfoundsection d-flex flex-wrap align-items-center mx-auto justify-content-center">
        <div className="row justify-content-center text-center">
          <div className="col-lg-4 mx-auto">
            <img src={pageData.image.url} className="pb-3" alt={pageData.image.title} />
            <h1 className="pb-2 copy-big fw-semi-bold">{pageData.heading}</h1>
            <div
              className="copy"
              dangerouslySetInnerHTML={{
                __html: sanitize(pageData.copy)
              }}
            ></div>
          </div>
        </div>
      </div>
    </>
  );
}

export async function getStaticProps() {

  try {
    let pageData = await getData("file_not_found_404_page");
    return {
      props: {
        pageData: pageData[0][0],
      },
    };
  } catch (error) {
    return { notFound: true };
  }
}
